import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { site } from "../content/site";
import PageHero from "../components/PageHero";

const Industries = () => {
  return (
    <>
      <PageHero
        eyebrow={site.industries.eyebrow}
        title={site.industries.title}
        intro={site.industries.intro}
        introSecondary={site.industries.introSecondary}
      />

      <section
        className="py-20 sm:py-28 border-b border-white/10"
        data-testid="industries-grid"
      >
        <div className="max-w-7xl mx-auto px-6 sm:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {site.industries.items.map((ind) => (
              <article
                key={ind.number}
                data-testid={`industry-card-${ind.number}`}
                className="group bg-[#711457] p-8 sm:p-10 hover:bg-[#5C0E45] transition-colors duration-300 min-h-[260px] flex flex-col"
              >
                <span
                  aria-hidden="true"
                  className="block w-2.5 h-2.5 bg-white/55 rotate-45"
                />
                <h3 className="mt-8 font-serif-display text-xl sm:text-2xl text-white leading-tight">
                  {ind.name}
                </h3>
                <p className="mt-4 text-sm font-sans-modern font-light text-white/55 leading-relaxed">
                  {ind.focus}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
          <p className="font-serif-display text-3xl sm:text-4xl text-white leading-tight">
            Working in a sector not listed?
          </p>
          <p className="mt-6 max-w-xl mx-auto text-base font-sans-modern font-light text-white/60 leading-relaxed">
            We selectively take on engagements outside our core sectors when
            the questions warrant it. Tell us what you are working on.
          </p>
          <Link
            to="/contact"
            data-testid="industries-cta"
            className="mt-10 inline-flex items-center justify-center h-12 px-10 bg-white text-[#711457] font-sans-modern font-semibold text-sm tracking-wide hover:bg-slate-200 transition-colors"
          >
            Begin a conversation
            <ArrowRight size={16} className="ml-2" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default Industries;
